import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.notice.user.detail');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import ClassicEditor from "src/libs/ckeditor/ckeditor";

@Component({
    selector: 'wiz-portal-notice-user-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.notice.user.detail/view.scss */
/* src/app/portal.notice.user.detail/view.scss: no such file or directory */`],
})
export class PortalNoticeUserDetailComponent implements OnInit, DoCheck {
    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @Input() category: any;
    @Input() docID: any;

    public info: any;
    public prev: any;
    public next: any;
    private lastUrl: string = "";
    public files: any;

    public async ngDoCheck() {
        if (this.router.url !== this.lastUrl) {
            this.lastUrl = this.router.url;
            this.docID = WizRoute.segment.id;
            this.load();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { docID: this.docID, category: this.category });
        if (code != 200) return await this.service.alert.error("Error!");
        this.info = data.info;
        this.info.attachments = JSON.parse(this.info.attachments.replace(/'/g, '"'));
        this.prev = data.prev;
        this.next = data.next;

        await this.service.render();
    }
}

export default PortalNoticeUserDetailComponent;